import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-PACKGE-TO-MODIFY-------------------------------------------------*/
export const getSouscriptionToModifyAction = (payload) => {
  return {
    type: ActionsTypes.GET_SOUSCRIPTION_TO_MODIFY,
    payload,
  };
};

export const getSouscriptionToModifySuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_SOUSCRIPTION_TO_MODIFY_SUCCESS,
    payload,
  };
};

export const getSouscriptionToModifyFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_SOUSCRIPTION_TO_MODIFY_FAIL,
    payload,
  };
};
/*---------------------------------------------ENVOI-MODIFICATION-SOUSCRIPTION-------------------------------------------------*/
export const modificationSouscriptionAction = (payload) => {
  return {
    type: ActionsTypes.MODIFICATION_SOUSCRIPTION,
    payload,
  };
};

export const modificationSouscriptionSuccessAction = (payload) => {
  return {
    type: ActionsTypes.MODIFICATION_SOUSCRIPTION_SUCCESS,
    payload,
  };
};

export const modificationSouscriptionFailAction = (payload) => {
  return {
    type: ActionsTypes.MODIFICATION_SOUSCRIPTION_FAIL,
    payload,
  };
};

export const modificationSouscriptionReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.MODIFICATION_SOUSCRIPTION_REINITIALIZATION,
    payload,
  };
};
